<template>
    <div>
        <div v-if="'text' in columnData" v-html="columnData.text"/>

        <a v-if="'url' in columnData"
           :href="columnData.url"
           target="_blank"
           class="link">
            {{columnData.caption}}
        </a>

        <a
            v-else-if="!'hide_empty' in columnData || !columnData.hide_empty || !!columnData.caption"
            class="link"
            @click="emitAction"
        >
            {{columnData.caption}}
        </a>
    </div>
</template>

<script>
export default {
    props: {
        rowId: Number,
        columnData: Object,
    },

    methods: {
        emitAction() {
            let params = {action: this.columnData.action, rowId: this.rowId};

            if ('params' in this.columnData) {
                params.params = this.columnData.params;
            }

            this.$emit('action', params);
        }
    }
}
</script>

<style scoped>

</style>
